import React, { useState } from 'react';
import styles from './Minecraft.module.css';

export const Minecraft: React.FC = () => {
  const [loading, setLoading] = useState(true);

  return (
    <div className={styles.container}>
      {loading && (
        <div className={styles.loading}>
          <div className={styles.loadingText}>Loading Skyblock World...</div>
        </div>
      )}
      <iframe
        src="https://game.kanteti.me/"
        title="Minecraft - Voxelize"
        className={styles.iframe}
        onLoad={() => setLoading(false)}
      />
      <div className={styles.controls}>
        <strong>WASD</strong> to move | <strong>SPACE</strong> to jump | <strong>Click</strong> to interact
      </div>
      <div className={styles.note}>
        Not loading? You may need to disable Enhanced Tracking Protection for this site.
      </div>
    </div>
  );
};
